<template lang="pug">
  #ItemsListIndex
    .container-width
      .saTop(v-if="profile && (profile.line_position === 'sa' || profile.line_position === 'sm')")
      .sicTop(v-if="profile && profile.line_position === 'sic'")
      .container
        .user_info
          .mr-3
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="profile.picture_url",
              :style="{ 'width': '80px', 'height': '80px' }"
            )
          .user_title.top_title Hi,
            span {{ profile.chinese_last_name}}{{ profile.chinese_first_name}}

        .message.shadow-btn.border-black(v-if="profile && (profile.line_position === 'sa' || profile.line_position === 'sm')")
          a.message_type.pl-0.pr-2( @click.stop.prevent="$router.push({ name: 'sa-inform-list-birthday'})")
            .message_text
              .message_icon.message_icon-birth
              span 本月壽星
              span.message_numer {{ birthList.length }}
            .message_arrow
              span.font-weight-normal >
          a.message_type.pl-0.pr-2( @click.stop.prevent="$router.push({ name: 'sa-inform-list-expired'})")
            .message_text
              .message_icon.message_icon-alert
              span 會籍到期提醒
              span.message_numer {{ expireRemindList.length }}
            .message_arrow
              span.font-weight-normal >

        ul.main_menu(:class="{ 'mt-5 supervisor' : profile && profile.line_position === 'sic'}")
          li(v-for="list in linePositionMenuList" :class='list.mainMenuClass')
            a(
              @click="toPath(list.routerPushName)"
            )
              .main_menu_icon.border-black.shadow-btn
              .main_menu_text
                span {{ list.name }}

</template>

<script>
  import { mapState } from 'vuex';

import { SA_MSG_MANAGER_INDEX } from '@/router/sa/msg-manager';
import { SA_RESERVATION_INDEX } from '@/router/sa/reservation';
import { SA_CONTACTS_INDEX } from '@/router/sa/contacts';
import { SA_LABEL_INDEX } from '@/router/sa/label';
import { SA_PROFILE_INDEX } from '@/router/sa/profile';
import { SA_MEMBER_SEARCH_INDEX } from '@/router/sa/member-search';
import { SA_REPORTS_INDEX } from '@/router/sa/reports';
import { SA_INVITATION_INDEX } from '@/router/sa/invitation';
import { SA_STORES_MANAGER_INDEX } from '@/router/sa/stores-manager';
import { SA_ORDER_ONLINE_INDEX } from '@/router/sa/order-online';
import { SA_STOCK_INDEX } from '@/router/sa/stock';
import { SA_TRIAL_PROGRAM_INDEX } from '@/router/sa/trial-program';
import { SA_POINTS_CARD_INDEX } from '@/router/sa/points-card';

import { SIC_DISTRICT_REPORTS_INDEX } from '@/router/sic/district-reports';
import { SIC_REPORTS_INDEX } from '@/router/sic/reports';
import { SIC_STORES_MANAGER_INDEX } from '@/router/sic/stores-manager';
import { SIC_MEMBER_SEARCH_INDEX } from '@/router/sic/member-search';
import { SIC_RESERVATION_INDEX } from '@/router/sic/reservation';
import { SIC_LABEL_INDEX } from '@/router/sic/label';
import { SIC_INVITATION_INDEX } from '@/router/sic/invitation';
import { SIC_BY_BA_REPORTS_INDEX } from '@/router/sic/by-ba-reports';
import { SIC_BY_COUNTER_REPORTS_INDEX } from '@/router/sic/by-counter-reports';

import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'ItemsListIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      saLists: [
        {
          mainMenuClass: 'main_menu-message',
          name: '訊息管理',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_MSG_MANAGER_INDEX
        },
        {
          mainMenuClass: 'main_menu-customer',
          name: '我的顧客',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_CONTACTS_INDEX
        },
        {
          mainMenuClass: 'main_menu-search',
          name: '顧客查詢',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_MEMBER_SEARCH_INDEX
        },
        {
          mainMenuClass: 'main_menu-tag',
          name: '顧客喜好',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_LABEL_INDEX
        },
        {
          mainMenuClass: 'main_menu-reservation',
          name: '預約查詢',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_RESERVATION_INDEX
        },
        {
          mainMenuClass: 'main_menu-invite',
          name: '邀請函',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_INVITATION_INDEX
        },
        {
          mainMenuClass: 'main_menu-info',
          name: '個人資料',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_PROFILE_INDEX
        },
        {
          mainMenuClass: 'main_menu-report',
          name: '報表',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_REPORTS_INDEX
        },
        {
          mainMenuClass: 'main_menu-preselect',
          name: '預選清單',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_ORDER_ONLINE_INDEX
        },
        {
          mainMenuClass: 'main_menu-trial',
          name: '試用計畫',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_TRIAL_PROGRAM_INDEX
        },
        {
          mainMenuClass: 'main_menu-mission',
          name: '集點卡',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_POINTS_CARD_INDEX
        },
      ],
      smLists: [
        {
          mainMenuClass: 'main_menu-message',
          name: '訊息管理',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_MSG_MANAGER_INDEX
        },
        {
          mainMenuClass: 'main_menu-customer',
          name: '我的顧客',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_CONTACTS_INDEX
        },
        {
          mainMenuClass: 'main_menu-search',
          name: '顧客查詢',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_MEMBER_SEARCH_INDEX
        },
        {
          mainMenuClass: 'main_menu-tag',
          name: '顧客喜好紀錄',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_LABEL_INDEX
        },
        {
          mainMenuClass: 'main_menu-reservation',
          name: '預約查詢',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_RESERVATION_INDEX
        },
        {
          mainMenuClass: 'main_menu-invite',
          name: '邀請函',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_INVITATION_INDEX
        },
        {
          mainMenuClass: 'main_menu-info',
          name: '個人資料',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_PROFILE_INDEX
        },
        {
          mainMenuClass: 'main_menu-report',
          name: '報表',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_REPORTS_INDEX
        },
        {
          mainMenuClass: 'main_menu-management',
          name: '櫃點管理',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_STORES_MANAGER_INDEX
        },
        {
          mainMenuClass: 'main_menu-preselect',
          name: '預選清單',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_ORDER_ONLINE_INDEX
        },
        {
          mainMenuClass: 'main_menu-stock',
          name: '庫存管理',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_STOCK_INDEX
        },
        {
          mainMenuClass: 'main_menu-trial',
          name: '試用計畫',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_TRIAL_PROGRAM_INDEX
        },
        {
          mainMenuClass: 'main_menu-mission',
          name: '集點卡',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SA_POINTS_CARD_INDEX
        },
      ],
      sicLists: [
        {
          mainMenuClass: 'main_menu-district',
          name: '區報表',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_DISTRICT_REPORTS_INDEX
        },
        {
          mainMenuClass: 'main_menu-report',
          name: '櫃點報表',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_REPORTS_INDEX
        },
        {
          mainMenuClass: 'main_menu-management',
          name: '櫃點管理',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_STORES_MANAGER_INDEX
        },
        {
          mainMenuClass: 'main_menu-search',
          name: '區顧客查詢',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_MEMBER_SEARCH_INDEX
        },
        {
          mainMenuClass: 'main_menu-reservation',
          name: '區預約查詢',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_RESERVATION_INDEX
        },
        {
          mainMenuClass: 'main_menu-tag',
          name: '顧客喜好',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_LABEL_INDEX
        },
        {
          mainMenuClass: 'main_menu-invite',
          name: '邀請函',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_INVITATION_INDEX
        },
        {
          mainMenuClass: 'main_menu-district',
          name: '顧問統計報表',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_BY_BA_REPORTS_INDEX
        },
        {
          mainMenuClass: 'main_menu-district',
          name: '櫃點統計報表',
          iconClassName: 'fas fa-envelope-open-text',
          routerPushName: SIC_BY_COUNTER_REPORTS_INDEX
        }
      ]
    };
  },
  computed: {
    ...mapState({
      profile: (state) => state.sa_profile.data,
      birthList: (state) => state.sa_inform_list.birthdayList,
      expireRemindList: (state) => state.sa_inform_list.expireRemindList,
      chatReadStatus: state => state.sa_item_list.chatReadStatus
    }),
    linePositionMenuList() {
      const vm = this;
      if (vm.profile && vm.profile.line_position === 'sa') {
        return vm.saLists;
      } else if (vm.profile && vm.profile.line_position === 'sm') {
        return vm.smLists;
      } else if (vm.profile && vm.profile.line_position === 'sic') {
        return vm.sicLists;
      } else {
        return [];
      }
    }
  },
  mounted() {
    const vm = this;
    const input = {
      per_page: 999999
    };
    vm.$store.dispatch('sa_item_list/getChatReadStatusHandler').then(() => {
      if (!vm.chatReadStatus) {
        vm.$swal.fire({
          icon: 'warning',
          title: '有未讀訊息，<br>請確認。',
          confirmButtonText: '確定',
        }).then(() => {});
      }
    });
    vm.$store.dispatch('sa_inform_list/getBirthMemberListHandler', input);
    vm.$store.dispatch('sa_inform_list/getExpireRemindMemberListHandler', input);

    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    toPath(routerPushName) {
      this.$router.push({ name: routerPushName });
    }
  }
};
</script>

<style scoped>
  .container-width {
    padding-bottom: 56px;
    padding-top: 50px;
  }
  .saTop {
    background-color: #000;
    width: 100%;
    border-radius: 0 0 1rem 1rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 12rem;
  }

  .sicTop {
    background-color: #000 !important;
    width: 100%;
    border-radius: 0 0 1rem 1rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 9rem;
  }

  .container {
    position: relative;
    z-index: 11;
    max-width: 640px;
    width: 100%;
    padding: 0 1.5rem 0;
  }

  .top_title {
    color: #FFF;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .shadow-btn {
    -webkit-box-shadow: 0.15rem 0.15rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.15rem 0.15rem 0 rgb(0 0 0 / 20%);
  }

  .user_info {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom:0.6rem;
  }

  .user_pic {
    width: 3.5rem;
    height:3.5rem;
    border: 0.2rem solid;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
    margin-right: 1rem;
  }

  .border-black {
    border: 0.2rem solid #000;
  }

  .message {
    font-size: 1.2rem;
    font-weight: 800;
    padding: 0 0.8rem;
    border-radius: 1rem;
    background-color: #fff;
  }

  .message_type {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.8rem;
  }

  @media (max-width: 60em) {
    .message_type {
      padding: 0.5rem 0.9rem;
    }
  }

  .message_type:first-child {
    border-bottom: 1px solid #6c757d;
  }

  .message_text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .message_icon {
    width: 1.5rem;
    height: 1.5rem;
    background-position: center;
    background-size: cover;
    margin-right: 0.4rem;
  }

  .message_icon-birth {
    background-image: url(../../../assets/images/icon/birth-1.png);
  }

  .message_icon-alert {
    background-image: url(../../../assets/images/icon/alert-1.png);
  }

  .message_numer {
    background-color: #ef4852;
    border-radius: 9487px;
    padding: 0rem 0.4rem;
    margin-left: 0.4rem;
    font-size: 0.9rem;
  }

  .message_arrow {
    font-size: 0.9rem;
    color: #6c757d;
  }

  .main_menu {
    padding: 0 3rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 1.3rem 0;
  }

  @media (max-width: 60em) {
    .main_menu {
      padding: 0;
    }
  }

  .main_menu_icon {
    position: relative;
    display: inline-block;
    width: 75%;
    height: 0;
    padding-bottom: calc(75% - 0.4rem);
    border-radius: 50%;
    margin-bottom: 0.2rem;
  }

  .main_menu_icon::after {
    content: '';
    width: 70%;
    height: 0;
    padding-bottom: 70%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    display: block;
    position: absolute;
  }

  .main_menu-district .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-district-1.png);
  }

  .main_menu-message .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-message-1.png);
  }

  .main_menu-reservation .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-reservation-1.png);
  }

  .main_menu-invite .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-invite-1.png);
  }

  .main_menu-customer .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-customer.png);
  }

  .main_menu-tag .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-tag-1.png);
  }

  .main_menu-info .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-info.png);
  }

  .main_menu-search .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-search-1.png);
  }

  .main_menu-report .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-report-1.png);
  }

  .main_menu-location .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-location-1.png);
  }

  .main_menu-management .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-management-1.png);
  }

  .main_menu-preselect .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-preselect-1.png);
  }
  .main_menu-stock .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-stock-1.png);
  }
  .main_menu-trial .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-trial-1.png);
  }
  .main_menu-mission .main_menu_icon::after {
    background-image: url(../../../assets/images/icon/icon-menu-mission-1.png);
  }

  .main_menu > li {
    width: 33.33%;
    text-align: center;
  }

  .main_menu > li:nth-child(1n + 4) {
    margin-top: 0.8rem;
  }

  .main_menu > li > a {
    width: 100%;
  }

  .main_menu_text {
    font-size: 0.8rem;
    font-weight: 500;
  }

  li {
    list-style: none;
  }

  a {
    text-decoration:none;
  }

</style>
